// extracted by mini-css-extract-plugin
export default {"RichTextEditor":"RichTextEditor_RichTextEditor__ezScm","Focus":"RichTextEditor_Focus__j6jkv"};